import { RootState } from "../rootReducer"

export const selectCurrentSubscriptionsState = (state: RootState) =>
    state.knowledgeBaseSubscriptions.currentSubscriptions
export const selectUpdateSubscriptionsState = (state: RootState) => state.knowledgeBaseSubscriptions.updateSubscriptions
